import React, { useEffect } from "react";
import { useAppContext, usePersistedState } from "../AppContext";
import { useTranslation } from "react-i18next";
import moment from "moment";
import func from "../services/functions";


export const PurchaseInvoiceContext = React.createContext(null);

export const usePurchaseInvoiceStore = () => React.useContext(PurchaseInvoiceContext);

let store;

export const getStore = () => ({ ...store });

export const PurchaseInvoiceContextProvider = ({ children }) => {
      const {
          user: [user],
          selectedCompany: [selectedCompany],
          company:[fullCompany]
        } = useAppContext();
        
      const { t } = useTranslation("translations");
      const [persistedData, setPersistedData] = usePersistedState(
          null,
          "sessionData"
      );
      const company = user?.companiesRights?.find(
        (company) => company.id === parseInt(selectedCompany)
      )
  
      const businessUnitCodes = React.useMemo(() => {
          return [{
              label: t("invoice.businessUnitCode"),
              value: null,
          }].concat((company?.branches?.map((branch) => {
              return {
                  label: branch.businUnitCode + " | " + branch.sellerName,
                  value: branch.businUnitCode,
              };
          })??[]))
      }, [company])
  
      const businessUnitSelected = businessUnitCodes.some(
          (branch) => branch?.value === persistedData?.businessUnitCode
      )
          ? persistedData?.businessUnitCode
          : null;

        // const [purchaseDates,setPurchaseDates]=React.useState({
        //   fromDate: fullCompany?.maxDaysPurchSearch?moment().subtract(fullCompany?.maxDaysPurchSearch,"days").add(1,"d")._d:func.getDateFromToday(-2),
        //   toDate: func.getDateFromToday(1),
        //   reloadData:false
        // })
      
        useEffect(()=>{
          if(fullCompany?.maxDaysPurchSearch){
              let fromDate=fullCompany?.maxDaysPurchSearch?moment().subtract(fullCompany?.maxDaysPurchSearch,"days").add(1,"d")._d:func.getDateFromToday(-2)
              setFilters((state)=>({...state,fromDate,reloadData:!state.reloadData}))
          }else{
            setFilters((state)=>({...state,reloadData:!state.reloadData}))
          }
      },[fullCompany])
      

      const filterParams = {
        dataFrom: "DB",
        search: "einvoice",
        internalStatus: [],
        purchaseUnit: [],
        priority: [],
        currency: [],
        checkUnknownBusiness: false,
        purchaseStatus: [],
    };

    const defaultFilters = {
      params: { ...filterParams },
      fromDate: fullCompany?.maxDaysPurchSearch?moment().subtract(fullCompany?.maxDaysPurchSearch,"days").add(1,"d")._d:func.getDateFromToday(-2),
      toDate: func.getDateFromToday(1),
  };

    const [filters, setFilters] = React.useState(defaultFilters);

    const store={
      filters,
      setFilters,
      defaultFilters,
      filterParams,
      persistedData,
      setPersistedData,
      businessUnitCodes,
      businessUnitSelected,
    }

  return <PurchaseInvoiceContext.Provider value={store}>{children}</PurchaseInvoiceContext.Provider>;
};
